import PropTypes from 'prop-types';
import React from 'react';
import ConfigConsumer from '../ConfigConsumer';
import { createContext } from '../tools/context';
export var PortalZIndexContext = createContext(10000);
export var PortalZIndexConsumer = PortalZIndexContext.Consumer;
export default function PortalZIndex(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
    var portalZIndexAdjust = _ref2.portalZIndexAdjust;
    return /*#__PURE__*/React.createElement(PortalZIndexConsumer, null, function (lastZIndex) {
      var zIndex = lastZIndex + 1;
      return /*#__PURE__*/React.createElement(PortalZIndexContext.Provider, {
        value: zIndex
      }, children(portalZIndexAdjust ? {
        zIndex: zIndex,
        style: {
          'z-index': zIndex
        },
        enable: true
      } : {
        style: {}
      }));
    });
  });
}
PortalZIndex.propTypes = {
  children: PropTypes.func.isRequired
};